import styled, { css } from "styled-components";
import { breakpoints } from "@theme/breakpoints";
import { Input } from "@components/atoms/Input";

const StyledWrapper = styled.div`
  gap: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoints.phoneMax`
    gap: 20px;
  `};
`;

const StyledInnerWrapper = styled.form<{ $block: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 340px;

  ${({ $block }) =>
    $block &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `};

  ${breakpoints.laptopMax`
    width: 100%;
    flex-direction: row;
    gap: 40px;
  `}

  ${breakpoints.phoneMax`
    flex-direction: column;
    gap: 30px;
  `};
`;

const StyledInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  ${breakpoints.laptopMax`
    flex-direction: row;
    gap: 26px;
    flex: 1;
  `}

  ${breakpoints.phoneMax`
    gap: 20px;
    flex-direction: column;
  `};
`;

const StyledInput = styled(Input)`
  ${breakpoints.laptopMax`
    max-width:270px;
  `};

  ${breakpoints.phoneMax`
    max-width: 100%;
  `};
`;

const AfterSendError = styled.span`
  color: ${({ theme }) => theme.error};
`;

export {
  StyledWrapper,
  StyledInnerWrapper,
  StyledInput,
  StyledInputsWrapper,
  AfterSendError,
};
